<p-skeleton class="flex-shrink-0" size="90px"/>
<div class="flex flex-col flex-1 gap-1">
  <p-skeleton height="1.2rem"></p-skeleton>
  <p-skeleton height="1rem"></p-skeleton>
  <p-skeleton height="1rem"/>
</div>
